export const SENTRY_DSN = {
  prod: 'https://20ecb81f6087434b81f593319f8c56da@sentry.io/175169',
  dev: 'https://0424650a52004021bb163d82a3de79c0@sentry.io/176302',
};



// WEBPACK FOOTER //
// ./src/config/sentry.js